<template>
  <div class="room-media-list-component">
    <div class="room-media-list">
      <div class="room-media-list-header">
        <div class="room-media-list-header-title">
          <span>{{ $t("media.list.title") }}</span>
          <button class="room-media-codec-info-btn" @click="isShowCodecInfo = !isShowCodecInfo" @blur="isShowCodecInfo = false">
            <div v-if="isShowCodecInfo" class="room-media-codec-info">
              <h5>{{ $t('media.list.forms')}}</h5>
              <p class="codec-list-tx">mp3, mp4(H.264), WebM(VP8, VP9), ogg</p>
            </div>
          </button>
        </div>
        <div class="room-media-list-header-button-container">
          <button class="room-media-list-header-button repeat" :class="repeatClass" v-tooltip.right="$t('media.list.repeat')" @click="onChangeRepeat"></button>
          <button class="room-media-list-header-button close" v-tooltip.right="$t('media.list.hide')" @click="onToggleMediaList"></button>
        </div>
      </div>
      <div class="room-media-list-body">
        <div class="room-media-list-body-button-wrapper">
          <button v-if="hasEmceeRole()" class="room-media-list-body-button add" @click="onUploadFile">{{ $t("media.list.add") }}</button>
        </div>
        <div class="room-media-file">
          <ul class="room-media-file-list">
            <li
              v-for="roomMediaFile in sortedRoomMediaFile(roomMedia)"
              :key="roomMediaFile.mediaId"
              :mediaId="roomMediaFile.mediaId"
              class="room-media-file-item"
              :class="{'play': roomMedia.mediaId == roomMediaFile.mediaId && isRoomMode('media')}"
            >
              <div class="room-media-file-info">
                <div class="room-media-file-start">
                  <p class="room-media-file-title">{{ roomMediaFile.mediaName }}</p>
                </div>
                <div class="room-media-file-end" :class="{ 'px-2': !hasEmceeRole() }">
                  <p class="room-media-file-time">{{ getDuration(roomMediaFile) }}</p>
                  <button v-if="hasEmceeRole()" class="room-media-file-button remove" @click="onRemoveRoomMediaFile(roomMediaFile)"></button>
                </div>
              </div>
              <button class="room-media-file-button start" @click="changeRoomMediaFile(roomMediaFile)"></button>
            </li>
          </ul>
          <ul>
            <li
            v-for="mediaFile in uploadRoomMediaFiles"
            :key="mediaFile.id"
            class="room-media-file-item"
            >
              <div class="room-media-file-info">
                <div class="room-media-file-start">
                  <p class="room-media-file-title">{{ mediaFile.filename }}</p>
                </div>
                <div class="room-media-file-end" :class="{ 'px-2': !hasEmceeRole() }">
                      <div class="room-media-file-progress">
                        <div class="room-media-file-progress-bar" :style="mediaFileProgressBar(mediaFile)"></div>
                      </div>
                  <button v-if="hasEmceeRole()" class="room-media-file-button remove" @click="onRemoveUploadMediaFile(mediaFile)"></button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'RoomMediaList',
  props: ['roomGroupId'],
  data() {
    return {
      playTypeList: ['', 'repeat_all', 'repeat_one'],
      isShowCodecInfo: false
    }
  },
  computed: {
    ...mapGetters('room', [
      'isRoomMode'
    ]),
    ...mapGetters('user', [
      'hasEmceeRole',
    ]),
    ...mapGetters('media',[
      'roomMedia',
      'sortedRoomMediaFile',
      'getRoomMedia',
      'getRoomMediaFile',
      'uploadRoomMediaFiles'
    ]),
    repeatClass() {
      if(this.roomMedia) {
        if(this.roomMedia.playType==='repeat_one') {
          return 'one'
        } else if(this.roomMedia.playType==='repeat_all') {
          return 'all'
        }
      }
      return 'none'
    },
    mediaFileProgressBar() {
      return mediaFile => {
        return {
          width: `${mediaFile.percent}%`
        }
      }
    },
    roomMedia: function () {
      return this.getRoomMedia(this.roomGroupId)
    },
    roomMediaFile: function () {
      return this.getRoomMediaFile(this.roomMedia)
    },
    mediaFile: function () {
      return this.roomMediaFile.mediaFile
    },
    getDuration() {
      return roomMediaFile => {
        if(!roomMediaFile.mediaFile || !roomMediaFile.mediaFile.duration) return;
        let duration = roomMediaFile.mediaFile.duration
        let mm = ('' + parseInt(duration / 60)).lpad(2, '0');
        let ss = ('' + parseInt(duration % 60)).lpad(2, '0');
        return mm + ':' + ss;
      }
    }
  },
  methods: {
    ...mapActions('room', [
       'changeRoomMode',
    ]),
    ...mapActions('media', [
      'changeRoomMedia',
      'removeRoomMediaFile',
      'changeRoomMediaPlayType',
      'removeUploadRoomMediaFile'
    ]),
    onChangeRepeat() {
      if (!this.hasEmceeRole()) {
        this.$alert(this.$t('media.list.noRole'));
        return;
      }

      if(!this.roomMedia) {
        console.warn('roomMedia is null ', roomGroupId);
        return;
      }

      let roomGroupId = this.roomMedia.roomGroupId
      let idx = this.playTypeList.indexOf(this.roomMedia.playType)
      let playType = this.playTypeList[(idx + 1) % this.playTypeList.length]

      this.changeRoomMediaPlayType({roomGroupId, playType})
    },
    onToggleMediaList() {
      this.$emit('onToggleMediaList')
    },
    onUploadFile() {
      if (!this.hasEmceeRole()) {
        this.$alert(this.$t('media.list.noRole'));
        return;
      }

      this.$emit('reqUploadMediaFile');
    },
    async changeRoomMediaFile(roomMediaFile) {
      if (!this.hasEmceeRole()) {
        this.$alert(this.$t('media.list.noRole'));
        return;
      }

      if(!roomMediaFile) return;

      await this.changeRoomMedia({
        roomGroupId: roomMediaFile.roomGroupId,
        mediaId: roomMediaFile.mediaId,
      });
      await this.changeRoomMode({ roomMode: 'media' })
    },
    onRemoveRoomMediaFile(roomMediaFile) {
      let THIS = this;
      this.$alert({
        title: this.$t('media.list.delete.title'),
        text: this.$t('media.list.delete.text'),
        ok() {
          THIS.removeRoomMediaFile(roomMediaFile);
        }
      })
    },
    onRemoveUploadMediaFile(roomMediaFile) {
      let THIS = this;
      this.$alert({
        title: this.$t('media.list.cancel.title'),
        text: this.$t('media.list.cancel.text'),
        ok() {
          THIS.removeUploadRoomMediaFile(roomMediaFile);
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.room-media-list-component {}
.room-media-list {
  border-radius: 4px;
  background-color: #4f4e5b;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  //overflow: hidden;
}
.room-media-list-header {
  height: 50px;
  padding: 6px 12px 6px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.room-media-list-header-title {
  display: flex;
  font-size: 17px;
  color: #fff;

  .room-media-codec-info-btn{
    position: relative;
    display: block;
    margin-left: 4px;
    width: 24px;
    height: 24px;
    background: url('~@/assets/images/info_white.svg') center no-repeat;
    background-size: 60%;

    .room-media-codec-info{
      position: absolute;
      top: 24px;
      left: 24px;
      z-index: 4;
      padding: 30px 15px;
      border-radius: 10px;
      background-color: #0f0f0f;
      color: #fff;
      white-space: nowrap;

      .codec-list-tx{
        margin-top: 10px;
        font-size: 14px;
      }
    }
  }
}
[grm-device-mobile]{
  .room-media-list-header-title {
    .room-media-codec-info {
      left: -50px;
      h5 {
        font-size: 14px;
      }
      .codec-list-tx {
        font-size: 12px;
      }
    }
  }
}
.room-media-list-header-button-container {
  display: flex;
  align-items: center;
  gap: 0 6px;
}
.room-media-list-header-button {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  opacity: 0.6;
  transition: 0.1s ease-out;
  &.repeat {
    &.none {
      background: url('~@/assets/images/repeat_white.svg') no-repeat center / 14px auto;
      &:hover {
        background-color: rgba(0, 0, 0, 0.6)
      }
    }
    &.all {
      background: rgba(0, 0, 0, 0.8) url('~@/assets/images/repeat_white.svg') no-repeat center / 14px auto;
      opacity: 0.8;
    }
    &.one {
      background: rgba(0, 0, 0, 0.8) url('~@/assets/images/repeat_one_white.svg') no-repeat center / 14px auto;
      opacity: 0.8;
    }
  }
  &.close {
    background: url('~@/assets/images/x_white.svg') no-repeat center / 12px auto;
  }
  &:hover {
    opacity: 1 !important;
  }
}
.room-media-list-body {
  border-top: 1px solid $mainColor;
}
.room-media-list-body-button-wrapper {}
.room-media-list-body-button {
  width: 100%;
  transition: 0.1s ease-out;
  &.add {
    background: #000 url('~@/assets/images/plus_white.svg') no-repeat center left 16px / 16px auto;
    color: #fff;
    line-height: 38px;
    opacity: 0.5;
    &:hover {
      background: $mainColor url('~@/assets/images/plus_white.svg') no-repeat center left 16px / 16px auto;
      opacity: 1;
    }
  }
}
.room-media-list-wrapper {}
.room-media-file {
  max-height: 50vh;
  overflow-y: auto;
}
.room-media-file-list {}
.room-media-file-item {
  height: 38px;
  color: rgba(255, 255, 255, 0.6);
  position: relative;
  &:nth-of-type(2n) {
    background-color: rgba(0, 0, 0, 0.15);
  }
  &::before {
    content: '';
    background: linear-gradient(to right, $mainColor, rgba(0, 153, 255, 0.2));
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: 0.1s ease-out;
  }
  &.play {
    &::before {
      opacity: 1;
    }
    .room-media-file-info {
      &::before {
        opacity: 1;
      }
    }
    .room-media-file-title {
      color: #fff;
    }
  }
  &.progress {
    pointer-events: none;
  }
  &:hover {
    .room-media-file-title {
      color: #fff;
    }
  }
}
.room-media-file-info {
  height: 100%;
  padding-left: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  &::before {
    content: '';
    width: 10px;
    height: 100%;
    background: url('~@/assets/images/play_white.svg') no-repeat center / 100% auto;
    position: absolute;
    left: 8px;
    opacity: 0;
    transition: 0.1s ease-out;
  }
}
.room-media-file-start {}
.room-media-file-title {
  font-size: 11px;
  transition: 0.1s ease-out;
  width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.room-media-file-end {
  height: 100%;
  display: flex;
  align-items: center;
}
.room-media-file-progress {
  width: 30px;
  height: 8px;
  border-radius: 2px;
  background-color: rgba(0, 0, 0, 0.4);
  overflow: hidden;
}
.room-media-file-progress-bar {
  height: 100%;
  background-color: $mainColor;
  transition: 0.1s ease-out;
}
.room-media-file-time {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
}
.room-media-file-button {
  height: 100%;
  transition: 0.1s ease-out;
  &.start {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  &.remove {
    width: 30px;
    background: url('~@/assets/images/trash_white.svg') no-repeat center / 14px auto;
    position: relative;
    pointer-events: auto;
    z-index: 1;
    opacity: 0.4;
    &:hover {
      background: url('~@/assets/images/trash_white.svg') no-repeat center / 16px auto;
      opacity: 1;
    }
  }
}
</style>